/**
 * Standard color palette for sidepot division badges.
 *
 * 1D → gold, 2D → silver, 3D → bronze, 4D → cyan (legible against both
 * day and night themes). Mirrors the medals convention so the announcer
 * can spot a rider's division at a glance.
 *
 * Each entry has:
 *   - `text`     Tailwind text color for the badge label
 *   - `bg`       Tailwind background tint
 *   - `border`   Tailwind border color
 *   - `placeText` Tailwind text color for the place-number text
 */
export const DIVISION_COLORS = {
  '1D': {
    text: 'text-[#FFD700]',
    bg: 'bg-[#FFD700]/10',
    border: 'border-[#FFD700]/40',
    placeText: 'text-[#FFD700]',
  },
  '2D': {
    text: 'text-[#C0C0C0]',
    bg: 'bg-[#C0C0C0]/10',
    border: 'border-[#C0C0C0]/40',
    placeText: 'text-[#C0C0C0]',
  },
  '3D': {
    text: 'text-[#CD7F32]',
    bg: 'bg-[#CD7F32]/10',
    border: 'border-[#CD7F32]/40',
    placeText: 'text-[#CD7F32]',
  },
  '4D': {
    text: 'text-[#0096FF]',
    bg: 'bg-[#0096FF]/10',
    border: 'border-[#0096FF]/40',
    placeText: 'text-[#0096FF]',
  },
};

export const getDivisionColors = (division) =>
  DIVISION_COLORS[division] || {
    text: 'text-[#9E9E9E]',
    bg: 'bg-[#262626]',
    border: 'border-[#3A3A3A]',
    placeText: 'text-[#FACC15]',
  };
